var render = function render(){var _vm=this,_c=_vm._self._c;return _c('policy-holder-container',[_c('router-view',_vm._b({ref:"routerView"},'router-view',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }